var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"label":_vm.label,"value":_vm.value,"hint":_vm.hinttext,"error":_vm.error,"color":"#E7AC18","rules":_vm.rules,"readonly":_vm.readonly,"outlined":_vm.outlined,"auto-grow":"","rows":_vm.rows,"disabled":_vm.disabled,"hide-details":"","autofocus":_vm.autofocus},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }